import { Box, Grid } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";

// import { RHookFormDatePicker } from "../../../RHookFormDatePicker";


interface IClientSuperUserManagementSetupFieldsPanel {
	isAdminUser: number;
	selectedDataRecord: any
}
export const ClientSuperUserManagementSetupFieldsPanel: FC<
	IClientSuperUserManagementSetupFieldsPanel
> = ({ isAdminUser, selectedDataRecord }) => {
	return (
		<Grid>
			<RHookFormDatePicker
				name="scheduleStartDate"
				testId="Schedule Start Date"
				label="Schedule Start Date"
				format="M dd, yy"
				disabled={selectedDataRecord && selectedDataRecord.haveEmployees}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Transaction Method"
				selectName="paymentSetup"
				testId={`Transaction-Method`}
				items={[
					{ label: "Pre Authorized Debit", value: 200 },
					{ label: "Wire Transfer", value: 300 },
					{ label: "Credit Card", value: 100 },
				]}
				selectedItem={200}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Is Direct Deposit required"
				selectName="isDirectDepositRequired"
				testId={`Is-Direct-Deposit-required`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Remittance Management"
				selectName="remittanceManagement"
				testId={`Remittance-Management`}
				items={[
					{ label: "Self", value: 100 },
					{ label: "SimplePay", value: 200 },
				]}
				selectedItem={100}
			/>
			<RHookFormDatePicker
				name="billingStartDate"
				testId="Billing-Start-Date"
				label="Billing Start Date"
				format="M dd, yy"
			/>
			<EnhancedDropDownRHFWithLabel
				label="Billing Status"
				selectName="billingStatus"
				testId={`Billing-Status`}
				items={[
					{ label: "Active", value: 100 },
					{ label: "Inactive", value: 200 },
				]}
				selectedItem={100}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Support Access Level can manager"
				selectName="supportAccessLevelCanManager"
				testId={`Support-Access-Level-can-manager`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Web ROE Managed by SimplePay"
				selectName="webROEManagedBySimplepay"
				testId={`Web-ROE-Managed-by-SimplePay`}
				items={[
					{ label: "No", value: 100 },
					{ label: "Yes", value: 300 },
					{ label: "Pending Approval", value: 200 },
				]}
				selectedItem={100}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Direct Deposit Processing"
				selectName="directDepositProcessing"
				testId={`Direct-Deposit-Processing`}
				items={[
					{ label: "SimplePay", value: 200 },
					{ label: "Self Managed", value: 100 },
				]}
				selectedItem={200}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Direct Deposit Cycle"
				selectName="directDepositCycle"
				testId={`Direct-Deposit-Cycle`}
				items={[
					{ label: "3 Days", value: 100 },
					{ label: "4 Days", value: 200 },
					{ label: "5 Days", value: 300 },
				]}
				selectedItem={200}
			/>
			<RHookFormTextFieldWithLabel
				label="Journal Code"
				id="journalCode"
				testId={`Journal-Code`}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Invoice Deduction"
				selectName="invoiceDeduction"
				testId={`Invoice-Deduction`}
				items={[
					{ label: "AP Account", value: 100 },
					{ label: "Company Account", value: 200 },
				]}
				selectedItem={200}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Show Accounting to Company"
				selectName="showAccountingToCompany"
				testId={`Show-Accounting-to-Company`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Activate Account"
				selectName="status"
				testId={`Activate-Account`}
				items={[
					{ label: "Yes", value: 100 },
					{ label: "No", value: 200 },
				]}
				selectedItem={200}
			/>
		</Grid>
	);
};
